import { useEffect, useState } from "react";

const KEY = "pgp_hover_preview";
const EVT = "pgp:hover-preview-changed";

// Preferenza condivisa: anteprima ingrandita al passaggio del mouse sugli allegati (default attiva).
export function useHoverPreviewPref() {
  const [on, setOn] = useState(() => localStorage.getItem(KEY) !== "0");
  useEffect(() => {
    const sync = () => setOn(localStorage.getItem(KEY) !== "0");
    window.addEventListener(EVT, sync);
    return () => window.removeEventListener(EVT, sync);
  }, []);
  const toggle = () => {
    localStorage.setItem(KEY, on ? "0" : "1");
    window.dispatchEvent(new Event(EVT));
  };
  return [on, toggle];
}
